import { useBetween } from '../../shared/use-between/use-between';
import { useEffect } from 'react';
import { ShoppingCartUseBetween } from '../order/use-between/shopping-cart-use-between';
import { IShopingCart } from '../order/interfaces/shopping-cart.interface';
import {
    getShoppingCart,
    getTotalQuantityShoppingCart,
    mapAndGetInitialFormValues,
} from './services/shopping-cart.service';

export default function ShoppingCartInitialize() {
    const { setQuantityShoppingCart } = useBetween(ShoppingCartUseBetween);
    const { setShoppingCart } = useBetween(ShoppingCartUseBetween);
    const { setBuildingSiteAddress } = useBetween(ShoppingCartUseBetween);
    const { setBuyerContact } = useBetween(ShoppingCartUseBetween);
    const { setIsReadyToOrder } = useBetween(ShoppingCartUseBetween);
    const { setInitialFormValues } = useBetween(ShoppingCartUseBetween);
    const { setIsSelfPickup } = useBetween(ShoppingCartUseBetween);

    const getAndSetShoppingCartItems = () => {
        getShoppingCart().then((response) => {
            if (response) {
                const data: IShopingCart = response.data;
                setShoppingCart(data);
                setQuantityShoppingCart(getTotalQuantityShoppingCart(data));
                setBuildingSiteAddress(data.buildingSiteAddress);
                setBuyerContact(data.buyerContact);
                setIsReadyToOrder(data.isReadyToOrder);
                setInitialFormValues(mapAndGetInitialFormValues(data.detail));
                setIsSelfPickup(data.detail?.isSelfPickup);
            }
        });
    };
    useEffect(() => {
        getAndSetShoppingCartItems();
    }, []);

    return <></>;
}
